import { type IInstructionFeedback } from "@/interfaces/api/instruction-feedback.interface"
import { type Moment } from "moment"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { BaseModelWithFiles } from "@/models/base-with-files.model"
import { ModelFactory } from "@/factories/model-factory"
import { InstructionFeedbackStatuses } from "@/enums/models/instruction-feedback-statuses"
import { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"

export class InstructionFeedback extends BaseModelWithFiles implements IInstructionFeedback {
  public static className = "InstructionFeedback" // Used for socket communication.
  public static verboseName = "instructie feedback"

  public static override managedResolveFields = ["serviceProvider"]

  id: string
  instruction: string

  serviceProvider: KnownBusinessEntityContact
  instructionFeedbackActivities: InstructionFeedbackActivity[]

  body: string
  status: InstructionFeedbackStatuses
  confirmedAt?: Moment

  constructor(instructionFeedback: IInstructionFeedback, managed = false) {
    super(instructionFeedback, managed)

    this.id = instructionFeedback.id
    this.instruction = instructionFeedback.instruction

    this.body = instructionFeedback.body
    this.status = instructionFeedback.status ?? InstructionFeedbackStatuses.IN_PROGRESS
    this.confirmedAt = instructionFeedback.confirmedAt

    this.serviceProvider = ModelFactory.childModel(
      KnownBusinessEntityContact,
      instructionFeedback.serviceProvider,
      managed
    )
    this.instructionFeedbackActivities = ModelFactory.childModels(
      InstructionFeedbackActivity,
      instructionFeedback.instructionFeedbackActivities,
      managed
    )
  }

  public sortInstructionFeedbackActivities() {
    this.instructionFeedbackActivities.sort((a, b) => (a.timeStart?.isBefore(b.timeStart) ? -1 : 1))
  }

  public hasActivities() {
    return this.instructionFeedbackActivities.length > 0
  }
}
